import { ref, watch, onMounted, type Ref, computed } from 'vue'
import { CustomersRepository } from '../repositories/modules/customers.ts';

import { supabase } from '../supabase.ts';

export function useCustomerListLoader<T>(
  fetcher: (repo: CustomersRepository, ...args: any[]) => Promise<{ data: T[] | null; error?: any}>,
  fetcherArgs: Ref<any[]> | (() => any[]),
  selectedTenant: Ref<string>
) {
  //const supabase =1
  //const user = initSupa()
  const loading = ref(false)
  const customerList = ref<T[]>([])

  const customersRepo = computed(() => new CustomersRepository(supabase, selectedTenant.value))

  const getCustomers = async () => {
    loading.value = true
    try {
      const args = typeof fetcherArgs === 'function' ? fetcherArgs() : fetcherArgs.value
      const response = await fetcher(customersRepo.value, ...args)
      customerList.value = response?.data ?? []
    } catch (error) {
      console.error('Error fetching customers:', error)
      customerList.value = []
    } finally {
      loading.value = false
    }
  }


  watch(selectedTenant, getCustomers)
  if (typeof fetcherArgs !== 'function') {
    watch(fetcherArgs, getCustomers)
  }

  return {
    customerList,
    loading,
    getCustomers
  }
}